const settings = {
  scene1: {
    title: 'How to clean decks',
    logo: 'https://coffee-f0843.firebaseapp.com/media/acf5b8a4-7300-45bb-95c7-03d95f183001.png',
    background: 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/users%2FZZopfaRHfENrj42VTqysoZXfC503%2F-KrAusNUFUxzii2R3E-k?alt=media&token=99e640dc-6270-43bb-ba74-5470b8998082'
  },
  scene2: {
    text1: 'Get ready to \'deck out\'',
    text2: 'your summer',
    bg: 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/users%2FZZopfaRHfENrj42VTqysoZXfC503%2F-KrBJ004qv58qTZsPQGA?alt=media&token=3f71ca3e-a8c0-4e91-b0d7-12b1220f11e3',
    logo: 'https://coffee-f0843.firebaseapp.com/media/acf5b8a4-7300-45bb-95c7-03d95f183001.png'
  },
  scene3: {
    video: {
      url: 'https://coffee-f0843.firebaseapp.com/media/83ead263-912b-43c3-83e4-520d1700374a.mp4',
      thumbUrl: 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/users%2FZZopfaRHfENrj42VTqysoZXfC503%2F-KrBU75ec-m4rAd0GChV?alt=media&token=d455e65c-1b23-43ff-bc8a-071d8ed5d2e4'
    },
    logo: 'https://coffee-f0843.firebaseapp.com/media/acf5b8a4-7300-45bb-95c7-03d95f183001.png',
    title: 'Brewing with a coffee press',
    description: 'Lorem ipsum coffee description, long enough for a couple of lines',
    button: 'Get started'
  },
  scene4: {
    subtitle: 'Step 1',
    title: 'Slide Header',
    description: 'Lorem ipsum coffee description, long enough for a couple of lines',
    tip: 'Lorem ipsum coffee tip, long enough for a couple of lines',
    logo: 'https://coffee-f0843.firebaseapp.com/media/acf5b8a4-7300-45bb-95c7-03d95f183001.png',
    bg: 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/users%2FZZopfaRHfENrj42VTqysoZXfC503%2F-KrG0Gd2JNnhu4scBNs8?alt=media&token=d3e514be-9a4e-4f9a-bf94-c2b225d1c519'
  },
  scene5: {
    subtitle: 'Step 2',
    title: 'Slide Header',
    description: 'Lorem ipsum coffee description, long enough for a couple of lines',
    tip: 'Lorem ipsum coffee tip, long enough for a couple of lines',
    logo: 'https://coffee-f0843.firebaseapp.com/media/acf5b8a4-7300-45bb-95c7-03d95f183001.png',
    bg: 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/users%2FZZopfaRHfENrj42VTqysoZXfC503%2F-KrG8q2VGbWFgiXp_1_S?alt=media&token=9810992f-cbd2-444a-83ff-6e99d2154940'
  },
  scene6: {
    subtitle: 'Step 3',
    title: 'Slide Header',
    description: 'Lorem ipsum coffee description, long enough for a couple of lines',
    tip: 'Lorem ipsum coffee tip, long enough for a couple of lines',
    logo: 'https://coffee-f0843.firebaseapp.com/media/acf5b8a4-7300-45bb-95c7-03d95f183001.png',
    bg: 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/users%2FZZopfaRHfENrj42VTqysoZXfC503%2F-KrG9YsDisoqkVfp-jOO?alt=media&token=2f23d734-3e9b-475c-8f39-c04c4d098e1e'
  },
  scene7: {
    subtitle: 'Step 4',
    title: 'Slide Header',
    description: 'Lorem ipsum coffee description, long enough for a couple of lines',
    tip: 'Lorem ipsum coffee tip, long enough for a couple of lines',
    logo: 'https://coffee-f0843.firebaseapp.com/media/acf5b8a4-7300-45bb-95c7-03d95f183001.png',
    bg: 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/users%2FZZopfaRHfENrj42VTqysoZXfC503%2F-KrG9YsDisoqkVfp-jOO?alt=media&token=2f23d734-3e9b-475c-8f39-c04c4d098e1e'
  },
  scene8: {
    logo: 'https://coffee-f0843.firebaseapp.com/media/acf5b8a4-7300-45bb-95c7-03d95f183001.png',
    title: 'More cleaning tips!',
    description: 'Revive your house and lifestyle with tips and tricks from Clorox!',
    bg: 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/users%2FZZopfaRHfENrj42VTqysoZXfC503%2F-KrAusNUFUxzii2R3E-k?alt=media&token=99e640dc-6270-43bb-ba74-5470b8998082',
    button: 'LEARN MORE',
    buttonUrl: 'https://google.com',
    facebook: 'https://fb.me/yay',
    twitter: 'https://twitter.com/me',
    email: '1@mail.com',
    phone: '+19723456789',
    shareTitle: 'title',
    shareSubtitle: 'subtitle',
    signUpButton: 'Sign Up',
    optionalBlockType: 'button'
  },
  appSettings: {
    title: 'Instant App'
  }
}

export default settings



// WEBPACK FOOTER //
// ./src/templates/bouncy/template/settings.js